/*
 * @Author: 1143190304 1143190304@qq.com
 * @Date: 2023-11-13 20:56:52
 * @LastEditors: 1143190304 1143190304@qq.com
 * @LastEditTime: 2023-12-10 23:26:38
 * @FilePath: \srddudbqd-web\src\utils\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 防抖
export function debounce(callback, timer = 400) {
  let tiemId = null;
  return function (...args) {
    if (tiemId !== null) {
      clearTimeout(tiemId);
      tiemId = null;
    }
    tiemId = setTimeout(() => {
      callback.call(this, ...args);
      clearTimeout(tiemId);
      tiemId = null;
    }, timer);
  };
}

// 节流
export function throttle(fn, wait = 600) {
  let pre = 0;
  return function (...args) {
    const context = this;
    const now = Date.now();
    if (now - pre >= wait) {
      fn.apply(context, ...args);
      pre = Date.now();
    }
  };
}
// 下载文件 Excel
export const exportFile = (res, fileName) => {
  if (!(res instanceof Blob)) return;
  const blob = new Blob([res], { type: "application/vnd.ms-excel" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("download", fileName);
  a.click();
  window.URL.revokeObjectURL(url);
};
/**
 * @description: 生成不重复id
 * @param {number} randomLength 随机值长度
 * @return {*}
 */
export function genNonDuplicateID(randomLength) {
  return Number(
    Math.random().toString().substr(3, randomLength) + Date.now()
  ).toString(36);
}

// 根据属性名找到当前数组项,找不到则默认传一个进来当默认值
export function getArrValByProps(arr, prop, defaultValue) {
  return arr.find((item) => item.defaultProps === prop) || { defaultValue };
}

export function objectSpanMethod(
  { row, column, rowIndex },
  tableData,
  propertyArr
) {
  // 需要合并单元格对应的列属性集合propertyArr
  if (!propertyArr || !tableData) return undefined;
  if (propertyArr.indexOf(column.property) !== -1) {
    // 需要校验的字段
    const data = propertyArr.slice(0, propertyArr.indexOf(column.property) + 1);
    // 每一条第一次出现时对应的索引
    const first = tableData.findIndex((item) => {
      return data.every((v) => item[v] === row[v]);
    });
    if (rowIndex === first) {
      // 同一条出现的条数
      const rowspan = tableData.filter((item) => {
        return data.every((v) => item[v] === row[v]);
      }).length;
      return {
        rowspan,
        colspan: 1,
      };
    } else {
      return {
        rowspan: 0,
        colspan: 0,
      };
    }
  }
}

// 去除多余的0
export const filterOtherEncode = (str = "") => {
  if (!str) return;
  let strLen = str.length;
  let result = str;
  while (strLen === result.length) {
    if (result[strLen - 1] === "0") {
      result = result.substring(0, strLen - 1);
    }

    strLen -= 1;
  }
  if (result[result.length - 1] === ".") {
    result = result.substring(0, result.length - 1);
  }
  return result;
};

// 督查立项中的一级任务和多个二级任务时候，需要将重复的二级任务聚合成一个
export const polymerization = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return [];
  let reObj = {};
  let normalList = [];
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].re) {
      if (!reObj[arr[i].re]) {
        reObj[arr[i].re] = [arr[i]];
      } else {
        reObj[arr[i].re].push(arr[i]);
      }
    } else {
      normalList.push(arr[i]);
    }
  }

  if (JSON.stringify(reObj) === "{}") return normalList;
  const reList = Object.keys(reObj).map((key) => {
    const id = reObj[key].reduce(
      (pre, item) => (pre ? `${pre},${item.id}` : `${item.id}`),
      ""
    );
    const organizer = reObj[key].reduce(
      (pre, item) => (pre ? `${pre},${item.organizer}` : `${item.organizer}`),
      ""
    );
    const organizerName = reObj[key].reduce(
      (pre, item) =>
        pre ? `${pre},${item.organizerName}` : `${item.organizerName}`,
      ""
    );
    const item = {
      ...reObj[key][0],
      id,
      organizer: organizer.split(","),
      organizerName: organizerName,
    };
    return item;
  });

  return reList.concat(normalList);
};

// 通过树形结构，找到对应名称的id项
export const getIdsByNames = (tree, names) => {
  let strs = names.split(",");
  let ids = [];
  const treeMap = function (list) {
    list.forEach((item) => {
      if (strs.includes(item.orgName)) {
        ids.push(item.orgId);
      }
      if (item.children) {
        treeMap(item.children);
      }
    });
  };
  treeMap(tree);
  return ids.join(",");
};

/**
 * 判断当前登录人与当前任务是否有相关操作的权限
 * btnList 后台返回的控制集合
 * operate 需要控制的相应操作
 */
export const hasPermission = (btnList, operate) => {
  return Array.isArray(btnList) && btnList.length > 0
    ? btnList.includes(operate)
    : false;
};
export const scrollToTop = () => {
  const scrollEle = document.querySelector(".container");
  scrollEle.scrollTo(0, 0);
};

export const setAreaTree = (tree, targetLevel, maxLevel) => {
  // 不传 maxLevel 就返回所有层级
  const finalMaxLevel = maxLevel ?? 999

  // 安全校验
  if (targetLevel >= finalMaxLevel) {
    console.error('错误：targetLevel 必须小于 maxLevel')
    return tree
  }

  // 递归处理
  function traverse(nodes) {
    return nodes.map(node => {
      const newNode = { ...node }

      // 1. 设置禁用：小于 targetLevel 不能选
      newNode.disabled = node.areaLevel < targetLevel

      // 2. 核心：当前层级 >= 要保留的最大层级 → 删掉所有子节点！
      if (node.areaLevel+1 >= finalMaxLevel) {
        newNode.children = null
        return newNode
      }

      // 3. 没超层级，才递归子节点
      if (newNode.children && newNode.children.length) {
        newNode.children = traverse(newNode.children)
      } else {
        newNode.children = null
      }

      return newNode
    })
  }

  return traverse(tree)
};
